import React from "react";

const Totalcar = ({ list, onClick }) => {
  if (!list) return;
  const object = list[0];

  return (
    <div>
      {list && list.length > 0 && (
        <div
          className="row justify-content-center
           align-items-center"
        >
          <div className="col-auto mx-2 text-center">
            <h3>
              <span
                className="badge rounded-pill bg-primary"
                style={{ cursor: "pointer" }}
                onClick={() => onClick(1)}
              >
                {object.Total}
              </span>
            </h3>
            จำนวนรถทั้งหมด
          </div>
          <div className="col-auto mx-2 text-center">
            <h3>
              <span
                className="badge rounded-pill bg-success"
                style={{ cursor: "pointer" }}
                onClick={() => onClick(2)}
              >
                {object.Active}
              </span>
            </h3>
            จำนวนรถกำลังทำงาน
          </div>
          <div className="col-auto mx-2 text-center">
            <h3>
              <span
                className="badge rounded-pill bg-warning text-dark"
                style={{ cursor: "pointer" }}
                onClick={() => onClick(3)}
              >
                {object.Standby}
              </span>
            </h3>
            จำนวนรถกำลังรองาน
          </div>
          <div className="col-auto mx-2 text-center">
            <h3>
              <span
                className="badge rounded-pill bg-danger"
                style={{ cursor: "pointer" }}
                onClick={() => onClick(4)}
              >
                {object.noActive}
              </span>
            </h3>
            จำนวนรถไม่ทำงาน
          </div>
        </div>
      )}
    </div>
  );
};

export default Totalcar;
